import { jsx as s } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import n from "@mui/material/Menu";
import p from "styled-components";
const m = {
  root: "menuRoot",
  paper: "menuPaper",
  list: "menuList"
}, d = {
  root: "listRoot"
}, l = p(n).withConfig({
  displayName: "StyledMenu"
})([
  "&& .menuPaper{min-width:200px;box-shadow:0px 4px 20px 0px ",
  ";padding:8px;box-sizing:border-box;}&& .menuList{padding:0;}"
], ({ theme: o }) => o.primaryShadow), u = /* @__PURE__ */ a(({ children: o = void 0, classes: t = {}, MenuListProps: r = {}, ...i }, e) => /* @__PURE__ */ s(l, {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  },
  transformOrigin: {
    // 8 pixels under the anchor
    vertical: -8,
    horizontal: "right"
  },
  ...i,
  ref: e,
  classes: {
    ...m,
    ...t
  },
  MenuListProps: {
    ...r,
    classes: d
  },
  children: o
}));
u.displayName = "Menu";
export {
  u as default
};
